<template>
  <div id="add-sma-mannual-payment">
    <overlay-loading-progress
      :LoadingFlag="OverlayLoadingFlag"
    ></overlay-loading-progress>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
        <v-spacer></v-spacer>
        <v-row wrap>
          <v-col align="right" cols="12" md="12">
            <v-btn
              @click="$router.push('/senior-life-member/list')"
              color="#1db954"
              elevation="30"
              rounded
              class="font-size-h6 mr-3 my-3 white--text d-inline-flex align-center"
              >List</v-btn
            >
            <v-btn
              medium
              @click.prevent="refreshPageData"
              color="#a4c639"
              elevation="30"
              rounded
              class="font-size-h6 mr-3 my-3 white--text"
              >&nbsp; Refresh &nbsp;
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- <v-card-subtitle class="text-h5">
          <h4>{{ PageDescription }}</h4>
        </v-card-subtitle> -->
      <v-card-text>
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="searchForm"
        >
          <v-container class="py-0">
            <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
              <b-spinner
                variant="primary"
                type="grow"
                label="Loading..."
              ></b-spinner>
            </div>
            <v-row>
              <h6 class="text-dark">
                <span class="text-danger">*</span> Notes:
              </h6>
              <v-col cols="12" sm="12" lg="12" md="12">
                <h6>1. The member should be an "Active member" in JAC</h6>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                lg="12"
                md="12"
                v-if="SeniorMemberType == 2"
              >
                <h6>1. The member should be an "Active member" in JAC</h6>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="6" md="4" lg="3" v-if="SeniorMemberTypeFlag">
                <h6><span class="text-danger">* </span> Senior Member Type</h6>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="SeniorMemberTypeOptions"
                  :rules="SeniorMemberTypeRules"
                  v-model="SeniorMemberType"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6><span class="text-danger">* </span> Membership Id</h6>
                <v-text-field
                  v-model="MembershipId"
                  placeholder="Enter Membership Id"
                  :rules="MembershipIdRules"
                  required
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-btn
                  @click.prevent="searchForm"
                  :disabled="!valid1"
                  :loading="SearchFlag"
                  elevation="30"
                  shaped
                  tile
                  small
                  color="primary"
                  class="font-size-h6 px-4 py-4 white--text"
                >
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-form
          ref="form2"
          v-model="valid2"
          lazy-validation
          v-on:submit.prevent="confirmAlert"
        >
          <v-container v-if="rows.MembershipId > 0">
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12" align="center">
                <v-img
                  v-if="rows.MemberImage"
                  :src="rows.MemberImage"
                  :alt="rows.Fullname"
                  lazy-src="/no-image-available.png"
                  height="100px"
                  width="100px"
                >
                </v-img>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Membership Id</h6>
                <h6 class="text-dark">{{ rows.MembershipId }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Member Name</h6>
                <h6 class="text-dark">{{ rows.Fullname }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Designation</h6>
                <h6 class="text-dark">{{ rows.MemberDesignation }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Current Role</h6>
                <h6 class="text-dark">{{ rows.RoleName }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> Zone
                </h6>
                <h6 class="text-dark">{{ rows.SmaZoneName }}</h6>
                <v-autocomplete
                  v-if="ZoneCodeFlag"
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> LO
                </h6>
                <h6 class="text-dark">{{ rows.LomName }}</h6>
                <v-autocomplete
                  v-if="LomCodeFlag"
                  :reduce="(option) => option.value"
                  :loading="LomCodeOptionsLoading"
                  :items="LomCodeOptions"
                  :rules="LomCodeRules"
                  v-model="LomCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> DOB
                </h6>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="DateOfBirth"
                      label="Date of Birth"
                      readonly
                      v-on="on"
                      background-color="#F3F6F9"
                      class="form-control form-control-lg form-control-solid"
                      validate-on-blur
                      solo
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="DateOfBirth"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> Mobile No
                </h6>
                <v-text-field
                  v-model="MobileNo"
                  :rules="MobileNoRules"
                  :counter="10"
                  v-mask="'##########'"
                  type="number"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> Email Id
                </h6>
                <v-text-field
                  v-model="EmailId"
                  placeholder="Enter Email Id"
                  :rules="EmailIdRules"
                  required
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> State
                </h6>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="StateCodeOptionsLoading"
                  :items="StateCodeOptions"
                  :rules="StateCodeRules"
                  v-model="StateCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> District
                </h6>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="DistrictCodeOptionsLoading"
                  :items="DistrictCodeOptions"
                  :rules="DistrictCodeRules"
                  v-model="DistrictCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> City
                </h6>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="CityCodeOptionsLoading"
                  :items="CityCodeOptions"
                  :rules="CityCodeRules"
                  v-model="CityCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <h6 class="text-primary">
                  <span class="text-danger">* </span> Address
                </h6>
                <v-text-field
                  v-model="Address"
                  :rules="AddressRules"
                  hint="Enter the address"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-if="Plan.PlanId > 0">
            <v-row wrap>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Plan Name</h6>
                <h6 class="text-dark">{{ Plan.PlanNameTxt }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Amount</h6>
                <h6 class="text-dark">{{ Plan.SubTotalTxt }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Amount</h6>
                <h6 class="text-dark">{{ Plan.TaxTxt }}</h6>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">Amount</h6>
                <h6 class="text-dark">{{ Plan.PlanAmountTxt }}</h6>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> Paid Date
                </h6>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="PaidDate"
                      label="Paid Date"
                      readonly
                      v-on="on"
                      background-color="#F3F6F9"
                      class="form-control form-control-lg form-control-solid"
                      validate-on-blur
                      solo
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="PaidDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> Transaction Type
                </h6>
                <v-select
                  :reduce="(option) => option.value"
                  :items="TransactionTypeOptions"
                  :rules="TransactionTypeRules"
                  v-model="TransactionType"
                  required
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  <span class="text-danger">*</span> Payment Id / Checque / DD
                  No.
                </h6>
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  hint="Enter the transaction reference no"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  GST Number <small>(Optional)</small>
                </h6>
                <v-text-field
                  v-model="GstNumber"
                  :rules="GstNumberRules"
                  hint="Enter the GST Number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <h6 class="text-primary">
                  Company Name <small>(Optional)</small>
                </h6>
                <v-text-field
                  v-model="CompanyName"
                  :rules="CompanyNameRules"
                  hint="Enter the company name"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="12" lg="12" md="12" align="center">
                <v-btn
                  :disabled="!valid2"
                  @click.prevent="confirmAlert"
                  :loading="SubmitFlag"
                  elevation="30"
                  shaped
                  tile
                  medium
                  color="success"
                  class="font-size-h6 px-6 py-4 mt-6 white--text"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid1: true,
      valid2: true,

      search: "",
      uploadPercentage: 0,
      OverlayLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      LoadingFlag: false,
      ResultFlag: false,

      SeniorMemberTypeOptions: [
        { value: 1, text: "Life Member" },
        { value: 2, text: "Priviledge Donor Member" },
      ],
      SeniorMemberTypeRules: [(v) => !!v || "Senior Member Type is required"],
      SeniorMemberType: "",
      SeniorMemberTypeFlag: true,

      MembershipIdRules: [(v) => !!v || "Membership Id is required"],
      MembershipId: "",

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,
      ZoneCodeFlag: false,

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,
      LomCodeFlag: false,

      EmailId: "",
      EmailIdRules: [
        (v) => !!v || "Email Id is required",
        (v) => /.+@.+\..+/.test(v) || "Email Id must be valid",
      ],

      MobileNo: "",
      MobileNoRules: [(v) => !!v || "Mobile Number is required"],

      WhatsappNo: "",
      WhatsappNoRules: [],

      PaidDate: "",
      PaidDateRules: [(v) => !!v || "Paid Date is required"],
      menu1: false,

      DateOfBirth: "",
      DateOfBirthRules: [(v) => !!v || "Date of birth is required"],
      menu2: false,

      TransactionType: "",
      TransactionTypeRules: [(v) => !!v || "Transaction Type is required"],
      TransactionTypeOptions: [],
      TransactionTypeOptionsLoading: false,

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment Id is required"],

      rows: {},
      Plan: {},

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      Address: "",
      AddressRules: [(v) => !!v || "Address is required"],

      GstNumber: "",
      GstNumberRules: [],

      CompanyName: "",
      CompanyNameRules: [],

      Qty: 1,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    rows: function () {
      console.log("watch rows called");
      this.ZoneCode = this.rows.SmaZoneId;
      this.LomCode = this.rows.LomId;
      this.MobileNo = this.rows.MobileNo;
      this.EmailId = this.rows.EmailId;
      this.DateOfBirth = this.rows.DOB;
      this.StateCode = this.rows.StateId;
      this.DistrictCode = this.rows.DistrictId;
      this.CityCode = this.rows.CityId;
      this.Address = this.rows.AddressTxt;
    },
    DateOfBirth: function () {
      console.log("watch DateOfBirth called");
      this.getPlanDetails();
      // this.ResultFlag = false;
    },
    SeniorMemberType: function () {
      console.log("watch SeniorMemberType called");
      var seniorMemberType = this.SeniorMemberType;
      console.log({ seniorMemberType });
      // this.MembershipId = "";
      // this.ResultFlag = seniorMemberType == 3 ? true : false;
      // this.resetAll();
    },
    TransactionTypeOptions: function () {
      console.log("watch TransactionTypeOptions");
      this.TransactionTypeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode called");
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions called");
      this.LomCodeOptionsLoading = false;
    },
    StateCodeOptions: function () {
      console.log("watch StateCodeOptions");
      this.StateCodeOptionsLoading = false;
    },
    StateCode: function () {
      console.log("watch StateCode");
      this.getDistrictCodeOptions();
    },
    DistrictCodeOptions: function () {
      console.log("watch DistrictCodeOptions");
      this.DistrictCodeOptionsLoading = false;
    },
    DistrictCode: function () {
      console.log("watch DistrictCode");
      this.getCityCodeOptions();
    },
    CityCodeOptions: function () {
      console.log("watch CityCodeOptions");
      this.CityCodeOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "sma_life_member",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    resetAll() {
      console.log("resetAll called");
      this.$refs.form1.reset();
      this.$refs.form2.reset();
      // this.SeniorMemberType = "";
      this.ResultFlag = false;
      this.rows = {};
      this.Plan = {};
    },
    pageData() {
      console.log("pageData called");
      // this.getZoneCodeOptions();
      this.getTransactionTypeOptions();
      this.getStateCodeOptions();
    },
    getZoneCodeOptions() {
      this.ZoneCodeOptions = [];
      console.log("getZoneCodeOptions called");
      var yearCode = this.CurrentYearId;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.CurrentYearId;
      var ZoneCode = this.ZoneCode;
      console.log("YearCode=" + YearCode + ", ZoneCode=" + ZoneCode);
      if (YearCode != "" && ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getTransactionTypeOptions() {
      console.log("getTransactionTypeOptions called");
      this.TransactionTypeOptionsLoading = true;
      var selectbox1_source = "TransactionType";
      var selectbox1_destination = "TransactionTypeOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        CategoryMainId: 3,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getStateCodeOptions() {
      console.log("getStateCodeOptions called");
      this.StateCodeOptionsLoading = true;
      var selectbox1_source = "StateCode";
      var selectbox1_destination = "StateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictCodeOptions() {
      console.log("getDistrictCodeOptions called");
      var StateCode = this.StateCode;
      StateCode = StateCode == (null || undefined) ? "" : StateCode;
      console.log({ StateCode });
      if (StateCode != "") {
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = "DistrictCode";
        var selectbox1_destination = "DistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions() {
      console.log("getCityCodeOptions called");
      var DistrictCode = this.DistrictCode;
      DistrictCode = DistrictCode == (null || undefined) ? "" : DistrictCode;
      console.log({ DistrictCode });

      if (DistrictCode != "") {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = "CityCode";
        var selectbox1_destination = "CityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getPlanDetails() {
      console.log("getPlanDetails is called");

      this.Plan = {};

      var DateOfBirth = this.DateOfBirth;
      DateOfBirth = DateOfBirth == (null || undefined) ? "" : DateOfBirth;
      console.log({ DateOfBirth });

      var SeniorMemberType = this.SeniorMemberType;
      console.log({ SeniorMemberType });

      if (DateOfBirth != "") {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/senior/life-member-plan/show";
        var upload = {
          UserInterface: SeniorMemberType == 1 ? 1 : 3,
          PlanType: SeniorMemberType,
          DateOfBirth: this.DateOfBirth,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );
        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Plan = records;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Date of birth is required";
        // thisIns.sweetAlert("error", output, false);
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      var SeniorMemberType = this.SeniorMemberType;
      var MembershipId = this.MembershipId;
      console.log({ SeniorMemberType }, { MembershipId });

      if (MembershipId != "") {
        this.OverlayLoadingFlag = true;
        this.SearchFlag = true;

        this.$refs.form2.reset();

        this.Member = {};
        this.rows = {};
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 11,
          MembershipId: this.MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );
        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.rows = records;

              var DobFlag = records.DobFlag;
              console.log({ DobFlag });
              thisIns.ResultFlag = DobFlag;
              if (!DobFlag) {
                // thisIns.sweetAlert("error", records.DobError, false);
              }
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Membership Id is required";
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");

      var message = "";

      var validate1 = this.$refs.form2.validate();
      var paid_date = this.PaidDate;
      console.log({ validate1 }, { paid_date });

      if (validate1 && paid_date != "") {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (paid_date == "") {
          message += "Paid date should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm called");

      var validate1 = this.$refs.form2.validate();
      var PaidDate = this.PaidDate;
      console.log({ validate1 }, { PaidDate });

      var tr = this.rows;
      console.log({ tr });

      if (validate1 && PaidDate != "") {
        this.SubmitFlag = true;
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/senior/life-member-order/add-manual-payment";
        var upload = {
          UserInterface: this.SeniorMemberType,
          SeniorMemberType: this.SeniorMemberType,
          Member: tr.MemberId,
          MembershipId: this.MembershipId,
          Zone: tr.SmaZoneId,
          Lom: tr.LomId,
          DateOfBirth: this.DateOfBirth,
          MobileNo: this.MobileNo,
          EmailId: this.EmailId,
          Qty: this.Qty,
          Plan: this.Plan.PlanId,
          PaidDate: PaidDate,
          TransactionType: this.TransactionType,
          PaymentId: this.PaymentId,
          City: this.CityCode,
          District: this.DistrictCode,
          State: this.StateCode,
          Address: this.Address,
          GstNumber: this.GstNumber,
          CompanyName: this.CompanyName,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.resetAll();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

  <style lang="scss"></style>
